import React, { Component } from 'react';
import MenuContainer from './components/menuContainer';
import ABSImage from '../../../../../components/ABSImage';
import routeConfig from '../../../../config/routeConfig';
import './index.less';
export interface IABSHomeLeftProps {
  login: boolean;
}
const calculator = require('../../../../../assets/images/calculator.png');
class ABSHomeLeft extends Component<IABSHomeLeftProps> {
    render() {
      const { login } = this.props;
      return (
          <div className="abs-home-left-content">
              <ABSImage logo={calculator} width={343} height={72} onClick={() => { location.href = routeConfig.calculator; }}/>
              <MenuContainer login={login}/>
          </div>
      );
    }
}

export default ABSHomeLeft; 


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/left/index.tsx